var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "14px",
    viewBox: "0 0 12 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "9C387D45-3487-456A-8010-B36E1F674D2F") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M4,1.33333333 C3.26666667,1.33333333 2.67333333,1.93333333 2.67333333,2.66666667 L2.66666667,13.3333333 C2.66666667,14.0666667 3.26,14.6666667 3.99333333,14.6666667 L12,14.6666667 C12.7333333,14.6666667 13.3333333,14.0666667 13.3333333,13.3333333 L13.3333333,5.33333333 L9.33333333,1.33333333 L4,1.33333333 Z M8.66666667,6 L8.66666667,2.33333333 L12.3333333,6 L8.66666667,6 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u041F\\u0440\\u043E\\u0442\\u043E\\u0442\\u0438\\u043F",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0440\\u0430\\u043A\\u0442-2-\\u0444\\u0438\\u043D-\\u0443\\u0441\\u043B\\u043E\\u0432\\u0438\\u044F-\\u0440\\u0430\\u0441\\u043A\\u0440\\u044B\\u0442\\u0438\\u0435",
    transform: "translate(-1073.000000, -447.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(300.000000, 230.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17-Copy",
    transform: "translate(30.000000, 196.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(22.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic/drive_file",
    transform: "translate(719.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_drive_file_24px"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "c/grey/600",
    mask: "url(#mask-2)",
    fill: "#45455A"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Shape",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIco);
export default __webpack_public_path__ + "static/media/file-ico.3a9311e6143d23784ca9c21ae03fe89d.svg";
export { ForwardRef as ReactComponent };